import React from 'react';
import type { Element } from '@/types';
import { Rectangle } from './Rectangle';
import { Ellipse } from './Ellipse';
import { Diamond } from './Diamond';
import { Arrow } from './Arrow';
import { Line } from './Line';
import { Text } from './Text';
import { IconComponent } from './IconComponent';
import { SvgElementComponent } from './SvgElement';
import { ImageElementComponent } from './ImageElement';
import { Group } from './Group';

interface ElementRendererProps {
  element: Element;
  isSelected: boolean;
}

export const ElementRenderer: React.FC<ElementRendererProps> = ({ 
  element, 
  isSelected 
}) => {
  switch (element.type) {
    case 'rectangle':
      return <Rectangle element={element} isSelected={isSelected} />;
    case 'ellipse':
      return <Ellipse element={element} isSelected={isSelected} />;
    case 'diamond':
      return <Diamond element={element} isSelected={isSelected} />;
    case 'arrow':
      return <Arrow element={element} isSelected={isSelected} />;
    case 'line':
      return <Line element={element} isSelected={isSelected} />;
    case 'icon':
      return <IconComponent element={element} isSelected={isSelected} />;
    case 'svg':
      return <SvgElementComponent element={element} isSelected={isSelected} />;
    case 'image':
      return <ImageElementComponent element={element} isSelected={isSelected} />;
    case 'text':
      return <Text element={element} isSelected={isSelected} />;
    case 'group':
      return <Group element={element} isSelected={isSelected} />;
    default:
      return null;
  }
}; 